import { MediaType } from '@types';
import { MEDIA_DOMAIN, THUMB_DOMAIN, PUBLIC_DOMAIN } from '@constants';

export const getUrlByMediaType = (
  mediaType: MediaType,
  src?: string
): string => {
  if (!src) return '';
  return `${
    mediaType === MediaType.system ? PUBLIC_DOMAIN : MEDIA_DOMAIN
  }${src}`;
};

export const getMediaUrl = (src?: string): string => {
  if (!src) return '';
  return `${MEDIA_DOMAIN}${src}`;
};

export const getSysUrl = (src?: string): string => {
  if (!src) return '';
  return `${PUBLIC_DOMAIN}${src}`;
};

export const getThumbUrl = (src?: string): string => {
  if (!src) return '';
  return `${THUMB_DOMAIN}${src}`;
};
